<template>
    <b-card no-body>
        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    name="tachograph-vehicle-driver"
                    pagination="server"
                    search>
                    </v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import EmployeeOperationsApi from '@/api/employee-operations' 
export default {
    components:{
        BCard
    },
    data(){
        return{
            fields:[
                { name:"Plaka",key:"CurrentPlate", thClass:"w-10",tdClass:'text-nowrap',sortable:true,},
                { name:"Eski Plaka",key:"OldPlate", thClass:"w-10",tdClass:'text-nowrap',sortable:true,},     
                { name:"Plaka Var Mı?",key:"VehiclePlateIsExists", thClass:"w-10",tdClass:'text-nowrap',sortable:true,},     
                { name:"Önceki Kart Çıkarılma Zamanı",key:"PreviousVehicleInfoWithdrawalTime", thClass:"w-10",tdClass:'text-nowrap',sortable:true,},     
                { name:"Kart Takılma Zamanı",key:"CardInsertionTimeStr", thClass:"w-10",tdClass:'text-nowrap',sortable:true,},     
                { name:"Kart Çıkarılma Zamanı",key:"CardWithdrawalTimeStr", thClass:"w-10",tdClass:'text-nowrap',sortable:true,},     
                { name:"Sürücü",key:"DriverFullName", thClass:"w-15",tdClass:'text-nowrap',sortable:true,},     
                { name:"Dijital Ehliyet No",key:"DriverCardNumber", thClass:"w-15",tdClass:'text-nowrap',sortable:true,},     
                { name:"İşlem Zamanı",key:"ActivityTimeStr", thClass:"w-10",tdClass:'text-nowrap',sortable:true,},     
            ]
        }
    },
    methods:{
        provider(data){
            return EmployeeOperationsApi.Tachograph.VehicleDriverCardMovement(data)
        }
    }
}
</script>

<style>

</style>